import { InjectionToken } from '@angular/core'
import { AuthConfiguration } from './auth-configuration'

export const DESKTOP_CONFIGURATION = new InjectionToken<AuthConfiguration>('DESKTOP_CONFIGURATION')

export interface DesktopConfiguration {
  desktopAppUrl: string
}
